import { render, staticRenderFns } from "./ForeignAgentFormDialog.vue?vue&type=template&id=28c74f56&scoped=true&"
import script from "./ForeignAgentFormDialog.vue?vue&type=script&lang=js&"
export * from "./ForeignAgentFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./ForeignAgentFormDialog.vue?vue&type=style&index=0&id=28c74f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c74f56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28c74f56')) {
      api.createRecord('28c74f56', component.options)
    } else {
      api.reload('28c74f56', component.options)
    }
    module.hot.accept("./ForeignAgentFormDialog.vue?vue&type=template&id=28c74f56&scoped=true&", function () {
      api.rerender('28c74f56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/foreign-agent/ForeignAgentFormDialog.vue"
export default component.exports